import type { HTMLAttributes, ReactNode, ThHTMLAttributes, TdHTMLAttributes, TableHTMLAttributes } from 'react';

interface TableProps extends Omit<TableHTMLAttributes<HTMLTableElement>, 'className'> {
  readonly className?: string;
  /** Use admin (denser) padding via .adm-tbl */
  readonly dense?: boolean;
  readonly children?: ReactNode;
}

export function Table({ className, dense, children, ...rest }: TableProps): JSX.Element {
  const cls = ['tbl', dense ? 'adm-tbl' : '', className ?? ''].filter(Boolean).join(' ');
  return (
    <table className={cls} {...rest}>
      {children}
    </table>
  );
}

interface RowProps extends Omit<HTMLAttributes<HTMLTableRowElement>, 'className'> {
  readonly className?: string;
  readonly clickable?: boolean;
  readonly children?: ReactNode;
}

export function TRow({ clickable, className, children, ...rest }: RowProps): JSX.Element {
  const cls = [clickable ? 'clickable' : '', className ?? ''].filter(Boolean).join(' ');
  return (
    <tr className={cls} {...rest}>
      {children}
    </tr>
  );
}

export function THead({ children, ...rest }: HTMLAttributes<HTMLTableSectionElement>): JSX.Element {
  return <thead {...rest}>{children}</thead>;
}

export function TBody({ children, ...rest }: HTMLAttributes<HTMLTableSectionElement>): JSX.Element {
  return <tbody {...rest}>{children}</tbody>;
}

export function TH({ children, ...rest }: ThHTMLAttributes<HTMLTableCellElement>): JSX.Element {
  return <th {...rest}>{children}</th>;
}

export function TD({ children, ...rest }: TdHTMLAttributes<HTMLTableCellElement>): JSX.Element {
  return <td {...rest}>{children}</td>;
}
